import React, { Fragment, memo, useMemo } from "react"
import { useToken } from "../../Modules/Login/useToken"
import { useSelector } from "react-redux"
import { selectUserCanteenId } from "../../Modules/User/userSelectors"
import { selectCurrentEnvironment } from "../../Modules/Environment/envSelectors"
import { IDeliveryFormExtraServiceItem } from "../../Types/MeetingPlanning/deliveryForm"
import { useQuery } from "../../Modules/Query/useQuery"
import ExtraServicesAccordion from "../../Modules/MeetingPlanning/Components/Layouts/ExtraServicesAccordion"
import { IExtraServicesItem } from "../../Types/MeetingPlanning/extraServices"
import { fetchMerchantProductsExtraServices } from "../../Modules/MeetingPlanning/Api/MeetingPlanningApi"

interface IExtraServicesSectionProps {
    name: string
    services: IExtraServicesItem[]
    seats: number
    selectedServices: IDeliveryFormExtraServiceItem[]
    setSelectedServices: (services: IDeliveryFormExtraServiceItem[]) => void
}

const ExtraServicesSection = ({ name, services, seats, selectedServices, setSelectedServices }: IExtraServicesSectionProps) => <>
    {
        services.map((service) => {
            return <Fragment key={service.id}>
                <ExtraServicesAccordion
                    name={name}
                    service={service}
                    seats={seats}
                    selectedServices={selectedServices}
                    setSelectedServices={setSelectedServices}
                />
            </Fragment>
        })
    }
</>

interface IExtraServicesControlProps {
    name: string
    seats: number
    selectedServices: IDeliveryFormExtraServiceItem[]
    setSelectedServices: (services: IDeliveryFormExtraServiceItem[]) => void
}

const ExtraServicesControl = ({ name, seats, selectedServices, setSelectedServices }: IExtraServicesControlProps) => {
    const token = useToken()
    const userCanteenId = useSelector(selectUserCanteenId)
    const environment = useSelector(selectCurrentEnvironment)

    const query = useQuery(
            () => fetchMerchantProductsExtraServices(token, userCanteenId!, environment),
            [token, userCanteenId, environment],
            Boolean(token && userCanteenId && environment)
        )

    return <query.QueryPane>
        {(data) => {
            return data?.services?.length ? <ExtraServicesSection name={name} services={data.services} seats={seats} selectedServices={selectedServices} setSelectedServices={setSelectedServices} /> : null
        }}
    </query.QueryPane>
}

export default memo(ExtraServicesControl)
